import { SanityImage, SanityQuote } from '../../types/generated/graphql-types'
import { Quote } from '../components/QuoteList'
import imageBuilder from '../sanity/imageBuilder'
import { NullCheckedSanityImage } from '../types/NullCheckedSanityImage'
import { validImage } from '../utilities/imageFilters'

export const sanityQuoteToQuote = ({
  authorName,
  authorRole,
  body,
  image,
}: SanityQuote): Quote => {
  let nullCheckedImage: NullCheckedSanityImage<SanityImage> | undefined = undefined
  if (validImage(image)) {
    nullCheckedImage = image
  }

  return {
    text: body ?? '',
    name: authorName ?? undefined,
    role: authorRole ?? undefined,
    imageUrl: nullCheckedImage
      ? imageBuilder
          .image(nullCheckedImage)
          .width(120)
          .height(120)
          .fit('crop')
          .auto('format')
          .url() ?? undefined
      : undefined,
  }
}
